<template>
  <div class="preview">
    <div class="row">
      <div class="col-12 col-md-6">
        <prism-editor
          id="code-editor" class="my-editor" v-model="valueMutable"
          :highlight="highlighter"
          line-numbers
          v-on:input="input"
        >
        </prism-editor>
      </div>
      <div class="col-12 col-md-6">
          <iframe :src="'data:text/html;charset=utf-8,'+renderValue"/>
      </div>
    </div>
  </div>
</template>

<script>
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css'; // import syntax highlighting styles

export default {
  name: 'HtmlPreview',
  components: {
    PrismEditor,
  },
  props: {
    content: {
      type: String,
      required: false,
    }
  },
  data: () => ({
    isPreview: true,
    valueMutable: '',
    renderValue: ''
  }),
  mounted() {
    this.valueMutable = this.content;
    this.render();
  },
  methods: {
    highlighter(code) {
      // languages.<insert language> to return html with markup
      return highlight(code, languages.js, languages.html);
    },
    input() {
      this.$emit('input', this.valueMutable);
      this.render();
    },
    render() {
      this.renderValue = encodeURIComponent(this.valueMutable);
    },
    toggle() {
      this.isPreview = !this.isPreview;
      if (this.isPreview) {
        this.htmlData = this.proccessString(
          this.$el.querySelector('.visual-preview').outerHTML
        );
      }
    },
    proccessString(string) {
      const div = document.createElement('div');
      div.innerHTML = string.trim();
      return this.formatString(div, 0).innerHTML;
    },
    formatString(node, level) {
      // eslint-disable-next-line no-param-reassign,no-plusplus
      const indentBefore = new Array(level++ + 1).join('  ');
      const indentAfter = new Array(level - 1).join('  ');
      let textNode;

      for (let i = 0; i < node.children.length; i += 1) {
        textNode = document.createTextNode(`\n${indentBefore}`);
        this.removeVueAttributes(node.children[i]);
        node.insertBefore(textNode, node.children[i]);

        this.formatString(node.children[i], level);

        if (node.lastElementChild === node.children[i]) {
          textNode = document.createTextNode(`\n${indentAfter}`);
          node.appendChild(textNode);
        }
      }
      return node;
    },

    removeVueAttributes(node) {
      const { attributes } = node;
      if (attributes) {
        let keys = Object.keys(attributes);
        for (let i = 0; i < keys.length; i += 1) {
          const attr = keys[i];
          if (attributes[attr].localName.includes('data-v')) {
            node.attributes.removeNamedItem(attributes[attr].localName);
            keys = Object.keys(attributes);
            i -= 1;
          }
        }
      }

      if (node.children) {
        for (let i = 0; i < node.children.length; i += 1) {
          this.removeVueAttributes(node.children[i]);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.my-editor {
  background: #2d2d2d;
  color: #ccc !important;
  max-height: 80vh;
  min-height: 60vh;
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;

  .prism-editor__container > pre {
    color: #ccc !important;
  }
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
  outline: none;
  color: #ccc !important;
}

.prism-editor__editor {
  color: #ccc !important;
}

#code-editor {
  color: #ccc;

  > div > pre {
    color: #ccc;
  }
}

iframe{
  width: 100%;
  height: 100%;
  min-height: 80vh;
}

</style>
